import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56f6c17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "inputFieldLabel" }
const _hoisted_3 = { for: "txtFirstName" }
const _hoisted_4 = {
  key: 0,
  class: "requiredField"
}
const _hoisted_5 = ["id", "title"]
const _hoisted_6 = { class: "validation-error" }
const _hoisted_7 = ["id", "placeholder", "disabled"]
const _hoisted_8 = ["id", "type", "placeholder", "min", "disabled"]
const _hoisted_9 = ["id", "type", "placeholder", "min", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _directive_cleave = _resolveDirective("cleave")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["inputField", _ctx.cssClass]),
    id: `txt${_ctx.name}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        (_ctx.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.langKey)), 1)
      ]),
      (_ctx.hasTooltip)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: "/Portals/0/Images/tooltip.png",
            id: `tooltip${_ctx.name}`,
            class: "tooltip",
            title: _ctx.$t(`${_ctx.langKey}Tooltip`)
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_ErrorMessage, {
        name: _ctx.name,
        class: "error"
      }, {
        default: _withCtx(({ message }) => [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.handleValidationMessage(_ctx.$t, message!)), 1)
        ]),
        _: 1
      }, 8, ["name"]),
      _createVNode(_component_Field, {
        name: _ctx.name,
        modelValue: _ctx.input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
        type: _ctx.inputType,
        label: _ctx.$t(_ctx.langKey),
        rules: _ctx.rules
      }, {
        default: _withCtx(({ field }) => [
          (_ctx.type == 'textarea')
            ? (_openBlock(), _createElementBlock("textarea", _mergeProps({ key: 0 }, field, {
                id: `txt${_ctx.name}`,
                rows: "5",
                class: ["input", {inputDisabled: _ctx.disabled}],
                placeholder: _ctx.placeholder,
                disabled: _ctx.disabled
              }), null, 16, _hoisted_7))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.cleave)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({ key: 0 }, field, {
                      id: `txt${_ctx.name}`,
                      type: _ctx.inputType,
                      class: ["input", {inputDisabled: _ctx.disabled}],
                      placeholder: _ctx.placeholder,
                      min: _ctx.inputType == 'number' ? _ctx.min : undefined,
                      disabled: _ctx.disabled
                    }), null, 16, _hoisted_8)), [
                      [_directive_cleave, _ctx.cleave]
                    ])
                  : (_openBlock(), _createElementBlock("input", _mergeProps({ key: 1 }, field, {
                      id: `txt${_ctx.name}`,
                      type: _ctx.inputType,
                      class: ["input", {inputDisabled: _ctx.disabled}],
                      placeholder: _ctx.placeholder,
                      min: _ctx.inputType == 'number' ? _ctx.min : undefined,
                      disabled: _ctx.disabled
                    }), null, 16, _hoisted_9))
              ], 64))
        ]),
        _: 1
      }, 8, ["name", "modelValue", "type", "label", "rules"])
    ])
  ], 10, _hoisted_1))
}